import React from "react";
import PropTypes from "prop-types";
import { MenuButton } from "../styles";

BoldButton.propTypes = {
  editor: PropTypes.object,
  disabled: PropTypes.bool,
};

export default function BoldButton({ editor, disabled = false }) {
  return (
    <MenuButton
      onClick={() => editor.chain().focus().toggleBold().run()}
      className={editor.isActive("bold") ? "is-active" : ""}
      disabled={disabled}
    >
      <span className="fas fa-bold" />
    </MenuButton>
  );
}
